import { useState, useEffect } from "react";

const APPLY_URL = "https://pro.form-mailer.jp/fms/e40aa43b232020";

const navLinks = [
  { label: "料金", href: "pricing" },
  { label: "お申し込み", href: "application" },
  { label: "クリニック", href: "about" },
  { label: "出張相談会", href: "consultation" },
  { label: "お問い合わせ", href: "contact" },
];

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 60);
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    setMenuOpen(false);
  };

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        isScrolled ? "bg-white shadow-sm" : "bg-transparent"
      }`}
    >
      <div className="max-w-6xl mx-auto px-6 flex items-center justify-between h-16">
        <button onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })} className="cursor-pointer flex items-center">
          <img
            src="https://static.readdy.ai/image/90b8495d3de38d7de3b4d3abd2a2907e/aab59213271533144a18b7088e97a4f4.jpeg"
            alt="クリニックロゴ"
            className="h-10 w-auto object-contain rounded"
          />
        </button>

        {/* Desktop nav */}
        <nav className="hidden md:flex items-center gap-6">
          {navLinks.map((link) => (
            <button
              key={link.href}
              onClick={() => scrollTo(link.href)}
              className={`cursor-pointer text-sm font-medium transition-colors whitespace-nowrap ${
                isScrolled ? "text-gray-700 hover:text-teal-700" : "text-white/90 hover:text-white"
              }`}
            >
              {link.label}
            </button>
          ))}
          <a
            href={APPLY_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="whitespace-nowrap cursor-pointer ml-2 bg-amber-500 hover:bg-amber-600 text-white text-sm font-semibold px-4 py-2 rounded-md transition-colors"
          >
            今すぐ申し込む
          </a>
        </nav>

        {/* Mobile menu button */}
        <button
          className={`md:hidden cursor-pointer w-8 h-8 flex flex-col items-center justify-center gap-1.5 ${
            isScrolled ? "text-gray-700" : "text-white"
          }`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="メニュー"
        >
          <span className={`block w-6 h-0.5 bg-current transition-all ${menuOpen ? "rotate-45 translate-y-2" : ""}`} />
          <span className={`block w-6 h-0.5 bg-current transition-all ${menuOpen ? "opacity-0" : ""}`} />
          <span className={`block w-6 h-0.5 bg-current transition-all ${menuOpen ? "-rotate-45 -translate-y-2" : ""}`} />
        </button>
      </div>

      {/* Mobile dropdown */}
      {menuOpen && (
        <div className="md:hidden bg-white border-t border-gray-100 px-6 py-4 flex flex-col gap-4">
          {navLinks.map((link) => (
            <button
              key={link.href}
              onClick={() => scrollTo(link.href)}
              className="cursor-pointer text-sm font-medium text-gray-700 hover:text-teal-700 text-left whitespace-nowrap"
            >
              {link.label}
            </button>
          ))}
          <a
            href={APPLY_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="whitespace-nowrap cursor-pointer bg-amber-500 hover:bg-amber-600 text-white text-sm font-semibold px-4 py-2 rounded-md text-center transition-colors"
          >
            今すぐ申し込む
          </a>
        </div>
      )}
    </header>
  );
}
